import { render, staticRenderFns } from "./traitsTab.vue?vue&type=template&id=e41eceb2&scoped=true&"
import script from "./traitsTab.vue?vue&type=script&lang=js&"
export * from "./traitsTab.vue?vue&type=script&lang=js&"
import style0 from "./traitsTab.vue?vue&type=style&index=0&id=e41eceb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e41eceb2",
  null
  
)

export default component.exports
import {QForm,QScrollArea,QInput,QSelect,QFile,QIcon,QToggle} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QScrollArea,QInput,QSelect,QFile,QIcon,QToggle})
